import React, { useState } from 'react';
import Table from '../common/SettlementsTable';
import tableConfig, { settlementTransactionTableConfig } from './config';
import { withRouter } from 'react-router-dom';
import { Tab, Tabs } from '@material-ui/core';
import "./settlemet.css"
import { DatePicker, Space } from 'antd';
import moment from 'moment';

const { RangePicker } = DatePicker;

const Settlements = (props) => {
  const classes = props.classes;
  const config = tableConfig(props);
  const historyConfig = settlementTransactionTableConfig()

  const [tableKey, setTableKey] = useState(1);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedDates, setSelectedDates] = useState([]);

  const handleChange = (event, selectedTab) => {
    setActiveTab(selectedTab);
  };

  const disabledDate = (current) => {
    return current && current > moment().endOf('day');
  };

  const isTransactionHistory = activeTab === 1

  return (
    <div>
      <div className='flex'>
        <Tabs
          value={activeTab}
          onChange={handleChange}
          classes={{ root: classes.tabRoot }}
        >
          <Tab label={`Pending Payments`} />
          <Tab label={`Transaction History`} />
        </Tabs>
        <div className='settlements-date-picker-wrap'>
          <Space direction="vertical" size={12}>
            <RangePicker
              disabledDate={disabledDate}
              value={selectedDates}
              onChange={(event) => {
                setSelectedDates(event)
              }} />
          </Space>
        </div>
      </div>
      <div className={`settlement-table-wrapper ${isTransactionHistory ? "transaction-history-table-wrapper" : ""}`}>
        <Table
          key={tableKey}
          selectedDates={selectedDates}
          isTransactionHistory={isTransactionHistory}
          tableConfig={isTransactionHistory ? historyConfig : config}
        />
      </div>
    </div>)
};

export default withRouter(Settlements);
